import { mapState } from 'vuex'

export const productRanking = {
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    hasPercentage() {
      return true
    },
    headers() {
      return [
        {
          text: 'Posição',
          width: '5%',
          value: 'index',
        },
        {
          text: 'Item',
          value: 'DES_PRODUTO',
        },
        {
          text: 'Cupons',
          value: 'NUM_CUPONS_TOTAL',
          align: 'right',
        },
        {
          text: 'Faturamento',
          value: 'VAL_FATURAMENTO_TOTAL',
          align: 'right',
        },
        {
          text: 'Clientes',
          value: 'NUM_CLIENTES_TOTAL',
          align: 'right',
        },
        {
          text: 'Quantidade',
          value: 'VAL_QUANTIDADE_KG_TOTAL',
          align: 'right',
        },
        ...(this.hasPercentage
          ? [
              {
                text: '%',
                value: 'PORCENTAGEM',
                align: 'right',
              },
            ]
          : []),
      ]
    },
  },
  async mounted() {
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filtrar', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filtrar')
  },
  methods: {
    async getData() {
      if (this.stateFilters.data?.[0]?.length > 0) {
        try {
          this.loading = true
          const filter = {
            date: this.stateFilters.data,
            unidades: this.stateFilters.unitsConfiguration,
            fidelidade: this.stateFilters.fidelidade,
            categoria_cliente: this.stateFilters.cliente,
            tipo_pessoa: this.stateFilters.pessoa,
            segmentos: this.stateFilters.segments,
          }
          const resp = this.internalGetData(filter)
          await Promise.all(resp)
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    },
    updateSelectedItems(itemsSort) {
      this.$emit('update-items', itemsSort)
    },
  },
}
